import { useChat } from "@/components/chat/ChatProvider";

export const PresenceToggle = () => {
  const { me, online, setPresence } = useChat();
  const on = me === "available";
  return (
    <div className="flex items-center gap-3">
      <span data-testid="chat-online-count" className="text-xs text-slate-500">{online.length} atendente(s) disponível(is)</span>
      <button data-testid="chat-presence-toggle" data-status={me} onClick={() => setPresence(on ? "away" : "available")}
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${on ? "border-emerald-500/40 bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25" : "border-[#1F293D] bg-[#111827] text-slate-400 hover:text-white"}`}>
        <span className={`h-2.5 w-2.5 rounded-full ${on ? "bg-emerald-400 shadow-[0_0_8px_#34d399]" : "bg-slate-500"}`} />
        {on ? "Disponível" : "Ausente"}
      </button>
    </div>
  );
};
